import { render, staticRenderFns } from "./RecoveryPassword2.vue?vue&type=template&id=77054a3c&"
import script from "./RecoveryPassword2.vue?vue&type=script&lang=js&"
export * from "./RecoveryPassword2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports